import React from 'react';
import createSvgIcon from './utils/create-svg-icon';
import { jsx as _jsx } from "react/jsx-runtime";
var Cross = createSvgIcon({
  path: [/*#__PURE__*/_jsx("path", {
    d: "M24.7071 8.69995C25.0976 8.30943 25.0976 7.68048 24.7071 7.28996C24.3165 6.89944 23.6876 6.89944 23.2971 7.28997L15.9985 14.5867L8.69996 7.28997C8.30943 6.89944 7.6805 6.89944 7.28998 7.28996C6.89945 7.68048 6.89943 8.30943 7.28996 8.69995L14.5864 15.9982L7.28996 23.2929C6.89944 23.6834 6.89944 24.3165 7.28996 24.7071C7.68049 25.0976 8.31365 25.0976 8.70418 24.7071L15.9985 17.4109L23.2929 24.7071C23.6834 25.0976 24.3166 25.0976 24.7071 24.7071C25.0976 24.3165 25.0976 23.6834 24.7071 23.2929L17.4106 15.9982L24.7071 8.69995Z",
    fill: "#050038"
  }, "0")],
  rect: [],
  displayName: 'Cross',
  viewBox: '0 0 32 32'
});
export default Cross;